export default[
  {
    path: '/main/addressBookManage',
    name: 'addressBookManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/addressMgr/addressMgr.vue')
  },
  {
    path: '/main/addressBookManageProject',
    name: 'addressBookManageProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/addressMgrProject/addressMgrProject.vue')
  },
  {
    path: '/main/addressBookManageGD',
    name: 'addressBookManageGD',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/addressMgrGD/addressMgrGD.vue')
  },
  {
    path: '/main/visitorManage',
    name: 'visitorManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/visitorManage/visitorInvite.vue')
  },
  {
    path: '/main/visitorManageProject',
    name: 'visitorManageProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/visitorManageProject/visitorInviteProject.vue')
  },
  {
    path: '/main/upphoto',
    name: 'upphoto',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/upPhoto')
  },
  // 安防管理
  {
    path: '/main/securityManage',
    name: 'securityManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/SafetyManage/SafetyManage.vue')
  },
  // 安防管理pro
  {
    path: '/main/securityManageProject',
    name: 'securityManageProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/SafetyManage/SafetyManageProject.vue')
  },
  {// 租客管理
    path: '/main/tenantManage',
    name: 'tenantManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/tenantManage/tenantManage.vue')
  },
  {// 例外权限管理
    path: '/main/exceptionPermissionManage',
    name: 'exceptionPermissionManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/exceptionPermissionManage/exceptionPermissionManage.vue')
  },
  {// 人员管理
    path: '/main/personManageProject',
    name: 'personManageProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/personManageProject/personManageProject.vue')
  },
  {// 批量续期
    path: '/main/personRenew',
    name: 'personRenew',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/personRenew')
  },
  {// 固定访客批量续期
    path: '/main/fixedVisitorRenew',
    name: 'fixedVisitorRenew',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'personManage' */ '../pages/personManage/fixedVisitorRenew')
  }
]



// WEBPACK FOOTER //
// ./src/router/personManage.js